import { silentRequest } from "../auth/authConfig";
import { IPublicClientApplication } from '@azure/msal-browser'
import { getRuntimeConfig } from "../utilities/runtimeConfig";


export default class API {
    private readonly basePath: string = "/api/v1"
    private readonly msalInstance: IPublicClientApplication;

    private getApiBaseUrl(): string {
        return getRuntimeConfig().apiBaseUrl;
    }

    constructor(msalInstance: IPublicClientApplication) {
        this.msalInstance = msalInstance;
        console.log("API initialized");
        console.log("API base path:", this.basePath);
    }

    public async getAccessToken() {
        const response = await this.msalInstance.acquireTokenSilent(silentRequest);
        return response.accessToken;
    }

    public async fetch(endpoint: string, options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    } as RequestInit, apiVersion: 'v1' | 'v4' = 'v1') {
        const apiPath = `/api/${apiVersion}${endpoint}`;
        const url = `${this.getApiBaseUrl()}${apiPath}`;
        console.log(`Fetching from URL: ${url}`);
        const accessToken = await this.getAccessToken();

        // Skip timeout for POST requests to /srp endpoint
        const exceptionEndpointList = [
            { method: 'POST', endpoint: '/api/v1/srp' },
            { method: 'POST', endpoint: '/api/v4/entrypoint/srps' },
            { method: 'POST', endpoint: '/api/v4/entrypoint/srps/validate' },
            { method: 'POST', endpoint: '/api/v1/cluster/signfile/metadata' },
        ];
        // const isPostToSrp = options.method === 'POST' && endpoint === '/srp';
        let controller: AbortController | null = null;
        let timeoutId: NodeJS.Timeout | null = null;

        if (!exceptionEndpointList.some(exception => exception.method === options.method && exception.endpoint === apiPath)) {
            // Create AbortController for timeout only if not POST to /srp
            controller = new AbortController();
            timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds
            options.signal = controller.signal;
        }

        options.headers = {
            ...options?.headers,
            'Authorization': `Bearer ${accessToken}`,
        }

        try {
            const response = await fetch(url, options);
            if (timeoutId) clearTimeout(timeoutId); // Clear timeout if request completes
            return response;
        } catch (error) {
            if (timeoutId) clearTimeout(timeoutId); // Clear timeout on error
            if (error.name === 'AbortError') {
                throw new Error('Request timed out after 10 seconds');
            }
            throw error; // Re-throw other errors
        }
    }
}